import { ReactNode } from 'react'

export interface TourTargetProps {
  id: string
  children: ReactNode
  inline?: boolean
}

export const TourTarget = ({ id, children, inline }: Readonly<TourTargetProps>) => (
  <div id={id} style={inline ? { display: 'inline-block' } : undefined}>
    {children}
  </div>
)
